import React, { useState } from 'react'
import ComboBox from '@react/react-spectrum/ComboBox'
import { TagList } from '@react/react-spectrum/TagList'

import Button from '@react/react-spectrum/Button'
import FilterAdd from '@react/react-spectrum/Icon/FilterAdd'
import FilterRemove from '@react/react-spectrum/Icon/FilterRemove'

import './Filter.scss'

export default function Filter({ label, defaultFilter, onChange, onRemove }) {
  const [input, setInput] = useState('')
  const [values, setValues] = useState(defaultFilter)

  const handleOnSelect = (val) => {
    if (values.indexOf(val) === -1) {
      setValues([...values, val])
      onChange(val)
    }
    setInput('')
  }

  const handleClose = (e) => {
    setValues(values.filter((v) => v !== e))
    onRemove(e)
  }

  const handleAddAll = (val) => {
    setValues(defaultFilter)
    onChange('addAll')
    setInput('')
  }

  const handleRemoveAll = (val) => {
    setValues([])
    onChange('removeAll')
    setInput('')
  }

  return (
    <div className='filter'>
      <div className='title'>
        {label}
        <div className='icon-box'>
          <Button variant='tool' icon={<FilterAdd />} aria-label='Add all' onClick={handleAddAll} />
          <Button variant='tool' icon={<FilterRemove />} aria-label='Remove all' onClick={handleRemoveAll} />
        </div>
      </div>
      <ComboBox
        value={input}
        className='combo-box'
        onChange={setInput}
        onSelect={handleOnSelect}
        options={defaultFilter}
        placeholder='Select Value'
        quiet={true}
        required={false}
      />

      <div className='tagList'>
        <TagList disabled={false} manageTabIndex onClose={handleClose} readOnly={false} values={values}></TagList>
      </div>
    </div>
  )
}
